import React from 'react';
import {
    SxProps,
    Table,
    TableBody,
    TableFooter,
    TableHead,
    Theme,
    Typography
} from '@mui/material';

import { ITableColumn, ITableGroups, TableBodyEntityList, TableRowGroupHeader, TableRowHeader } from './TableLayouts';

export type TotalsRowMap<T> = {
    columnIndex: number,
    entityField: keyof T,
    sxOverride?: SxProps<Theme>
}

export interface TableListProps<T> {
    entityList: T[] | null | undefined,
    columns: ITableColumn[],
    columnGroups?: ITableGroups[],
    isLoading: boolean,
    error: any,
    noDataMessage?: string | null,
    footer?: React.ReactNode; // Nueva propiedad opcional para el footer
}

export function TableList<T>(props: TableListProps<T>) {
    return (
        <Typography component="div"
                    sx={{
                        flexGrow: 1,
                        marginTop: 0,
                        overflowX: 'auto !important'
                    }}
        >
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    {
                        props?.columnGroups &&
                        <TableRowGroupHeader columns={props.columnGroups} />
                    }
                    <TableRowHeader columns={props.columns} />
                </TableHead>
                <TableBody>
                    <TableBodyEntityList<T> entityList={props.entityList}
                                            columns={props.columns}
                                            isLoading={props.isLoading}
                                            error={props.error}
                                            noDataMessage={props.noDataMessage}
                    />
                </TableBody>
                {
                    props.footer && (
                        <TableFooter>
                            {props.footer}
                        </TableFooter>
                    )
                }
            </Table>
        </Typography>
    )
}
